import ClientBindVehicleInfoModal from './client-bind-vehicle-info-modal.vue'
export default ClientBindVehicleInfoModal
